<template>
  <div class="mt-4  px-5">
    <h2>Feedback</h2>
    <v-data-table
        :headers="headers"
        :items="comp_Feedbacks"
        sort-by="created_at"
        class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar
            flat
        >
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>

      <template v-slot:item.created_at="{ item }">

            <span v-show="item.created_at !== null">
               {{ new Date(item.created_at).toLocaleString([], {dateStyle: 'short', timeStyle: 'short'}) }}
            </span>

      </template>

      <template v-slot:no-data>
        <v-btn
            color="primary"
            @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'Feedback',
  data: () => ({
    headers: [
      {
        align: 'Kurz',
        sortable: false,
      },
      {text: 'Name', value: 'name'},
      {text: 'E-Mail', value: 'email'},
      {text: 'Nachricht', value: 'message'},
      {text: 'Erstellt', value: 'created_at'}
    ],

  }),
  computed: {
    comp_Feedbacks: {
      get() {
        return this.$store.state.AdminApp.FEEDBACK;
      }
    },
  },
  mounted() {
    this.getFeedback();
  },
  methods: {
    getFeedback() {
      this.$store.dispatch('AdminApp/getFeedback');
    },
    initialize() {
      this.getFeedback();
    },
  },
}
</script>

<style scoped>

</style>